import React from 'react';

interface NavigationItem {
  name: string;
  url: string;
  description?: string;
}

interface NavigationSchemaProps {
  baseUrl?: string;
}

const NavigationSchema: React.FC<NavigationSchemaProps> = ({
  baseUrl = "https://fownd.care"
}) => {
  const navigationItems: NavigationItem[] = [
    {
      name: "Notation Platform",
      url: `${baseUrl}/notation`,
      description: "AI-powered SOAP note generation platform for physical therapy"
    },
    {
      name: "ROI Calculator",
      url: `${baseUrl}/roi-calculator`,
      description: "Calculate return on investment for AI documentation solutions"
    },
    {
      name: "Blogs",
      url: `${baseUrl}/blogs`,
      description: "Latest insights on AI in healthcare and physical therapy"
    },
    {
      name: "About Us",
      url: `${baseUrl}/about`,
      description: "Learn about Fownd's mission and team"
    },
    {
      name: "Contact",
      url: `${baseUrl}/contact`,
      description: "Get in touch with our team"
    }
  ];

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": navigationItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  const siteNavigationSchema = {
    "@context": "https://schema.org",
    "@type": "SiteNavigationElement",
    "name": "Main Navigation",
    "url": baseUrl,
    "hasPart": navigationItems.map(item => ({
      "@type": "WebPage",
      "name": item.name,
      "url": item.url,
      "description": item.description
    }))
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(breadcrumbSchema)
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(siteNavigationSchema)
        }}
      />
    </>
  );
};

export default NavigationSchema; 